// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import App from './App'
import router from './router'

import axios from 'axios'
import VueAxios from 'vue-axios'
import VueAuth from '@websanova/vue-auth'
import VueAuthUtils from '@websanova/vue-auth/src/lib/utils.js'
import lodash from 'lodash'
import VueLodash from 'vue-lodash'
import VueToastr from '@deveodk/vue-toastr'
import datePicker from 'vue-bootstrap-datetimepicker'
import VeeValidate, {
  Validator
} from 'vee-validate'
import messages from 'vee-validate/dist/locale/pt_PT.js'
import kendo from '@progress/kendo-ui/js/kendo.all.js' // eslint-disable-line no-unused-vars
import '@progress/kendo-ui/js/cultures/kendo.culture.pt-PT.js' // eslint-disable-line no-unused-vars
import '@progress/kendo-ui/js/messages/kendo.messages.pt-PT.js' // eslint-disable-line no-unused-vars
import StatisticsGrid from '@/components/StatisticsGrid.vue'
import SellinGrid from '@/components/SellinGrid.vue'
// import AccountsGrid from '@/components/AccountsGrid.vue'
import GenericGrid from '@/components/GenericGrid.vue'
import yourMoment from 'moment'
import VueScrollTo from 'vue-scrollto'
import VueCurrencyFilter from 'vue-currency-filter'

// import APIURL from './constants' // eslint-disable-line no-unused-vars
// var $ = require('jquery') // eslint-disable-line no-unused-vars
// import '@progress/kendo-ui/js/kendo.all.js'
// import '@progress/kendo-theme-bootstrap/dist/all.css'
import '@deveodk/vue-toastr/dist/@deveodk/vue-toastr.css'
import 'eonasdan-bootstrap-datetimepicker/build/css/bootstrap-datetimepicker.css'

console.log(Window.appConfig)
kendo.culture('pt-PT')
Window.prototype.$ = kendo.jQuery

function percent(a, b) {
  if (b === 0) {
    return 0
  }
  return Math.round(a / b * 10000) / 100
}
Window.prototype.percent = percent

function growth(a, b) {
  if (b === 0) {
    return 0
  }
  return Math.round((a - b) / b * 10000) / 100
}
Window.prototype.growth = growth

function growthFormat(p) {
  var icon = '<i class="fa fa-minus"></i>'
  if (p > 0) {
    icon = '<i class="fa fa-arrow-up text-success"></i>'
  } else if (p < 0) {
    icon = '<i class="fa fa-arrow-down text-danger"></i>'
  } else {
    icon = '<i class="fa fa-equals text-secondary"></i>'
  }
  return kendo.toString(p, 'n1') + '% ' + icon
}
Window.prototype.growthFormat = growthFormat

yourMoment.locale('pt')
Vue.prototype.$moment = yourMoment

Vue.use(BootstrapVue)
Vue.use(VueToastr, {
  defaultPosition: 'toast-top-center',
  defaultType: 'info',
  defaultTimeout: 1000
})
Vue.use(VueCurrencyFilter, {
  symbol: '€',
  thousandsSeparator: '.',
  fractionCount: 2,
  fractionSeparator: ',',
  symbolPosition: 'back',
  symbolSpacing: true
})
var apiRoot = process.env.API_ROOT
if (typeof Window.appConfig !== 'undefined' && Window.appConfig.baseUrl !== 'undefined') {
  apiRoot = Window.appConfig.baseUrl
}
Vue.prototype.APIURL = apiRoot
axios.defaults.baseURL = apiRoot
Vue.use(VueAxios, axios)
Vue.use(require('@websanova/vue-upload'), {
  http: function(data) {
    this.Vue.axios.post(data.url, data.body, {
      progress: data.progress
    }).then(data.success, data.error)
  }
})
Vue.router = router

Object.defineProperty(Vue.prototype, '$lodash', {
  value: lodash
})
Vue.use(VueScrollTo)
Vue.use(VueLodash, lodash)
Vue.use(datePicker)

const isUniqueUsername = (value, args) => {
  return Vue.axios.post('users/username', {
    username: value,
    user_id: args[0]
  }).then((response) => {
    // Notice that we return an object containing both a valid property and a data property.
    return {
      valid: response.data.valid,
      data: {
        message: response.data.message
      }
    }
  })
}
const isUniqueEmail = (value, args) => {
  return Vue.axios.post('users/email', {
    email: value,
    user_id: args[0]
  }).then((response) => {
    // Notice that we return an object containing both a valid property and a data property.
    return {
      valid: response.data.valid,
      data: {
        message: response.data.message
      }
    }
  })
}

Vue.use(VeeValidate, {
  locale: 'pt_PT',
  inject: true,
  fieldsBagName: 'veeFields'
})
messages.attributes = {
  email: 'Email',
  name: 'Nome',
  username: 'Nome de utilizador',
  password: 'Palavra-passe',
  password_confirm: 'Confirme a palavra-passe'
}
Validator.localize('pt_PT', messages)
// The messages getter may also accept a third parameter that includes the data we returned earlier.
Validator.extend('username', {
  validate: isUniqueUsername,
  getMessage: (field, params, data) => {
    console.log(data)
    return data.message
  }
})
Validator.extend('uniqueemail', {
  validate: isUniqueEmail,
  getMessage: (field, params, data) => {
    console.log(data)
    return data.message
  }
})
// Vue.axios.defaults.baseURL = Vue.APIURL
// Vue.prototype.$http = Vue.axios

Vue.use(VueAuth, {
  auth: require('./auth/bearer.js'),
  http: require('@websanova/vue-auth/drivers/http/axios.1.x.js'),
  router: require('@websanova/vue-auth/drivers/router/vue-router.2.x.js'),
  authRedirect: {
    path: '/login'
  },
  fetchData: {
    url: 'users/me'
  },
  refreshData: {
    url: 'auth/refresh',
    interval: 60
  },
  // rolesVar: 'permissions'
  check: function(role) {
    if (this.watch.authenticated === true) {
      if (role) {
        if (VueAuthUtils.compare('superuser', this.watch.data['permissions'])) {
          return true
        }
        return VueAuthUtils.compare(role, this.watch.data['roles']) || VueAuthUtils.compare(role, this.watch.data['permissions'])
      }
      return true
    }
    return false
  }
})
Vue.auth.perms = function(perm) {
  return this.options.check.call(this, perm, 'permissions')
}

Vue.component('statistics-grid', Vue.extend(StatisticsGrid))
Vue.component('sellin-grid', Vue.extend(SellinGrid))
// Vue.component('accounts-grid', Vue.extend(AccountsGrid))
Vue.component('generic-grid', Vue.extend(GenericGrid))

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: {
    App
  }
})



// WEBPACK FOOTER //
// ./src/main.js